import type { SistemaIntegradoIdpk } from '@/features/sistema-integrado/enum';
import { fetchApi } from '@/std/api/fetchApi';
import { EmpresaSlugTokenSchema } from '../types/EmpresaSlugToken';

type EmpresaSlugClienteRenovarTokenParams = {
    empresa_idpk: number;
    sistema_integrado_idpk: SistemaIntegradoIdpk;
};

export function apiEmpresaSlugClienteRenovarToken(params: EmpresaSlugClienteRenovarTokenParams) {
    return fetchApi({
        empresaIdpk: false,
        endpoint: 'EmpresaSlug/ClienteRenovarToken',
        method: 'post',
        params,
        schema: EmpresaSlugTokenSchema,
    });
}
